<template>
  <div>
    <a-modal
        v-drag-modal
        wrap-class-name="custom-modal-wrap"
        v-model="localVisible"
        :footer="null"
        :confirmLoading="loading"
        :maskClosable="false"
        @cancel="cancel"
        @ok="confirm">
      <div slot="title">查看</div>
      <div>
        <a-form-model ref="form" :model="localForm" :rules="rules" :label-col="{ span: 6 }" :wrapper-col="{ span: 16 }">
          <a-form-model-item prop="product_id" label="商品">
            <a-select disabled v-model="localForm.product_id">
              <a-select-option v-for="val in productList" :key="val.goods.id" :value="val.goods.id">
                {{ val.product_name }}
              </a-select-option>
            </a-select>
          </a-form-model-item>
          <a-form-model-item prop="date" label="批次">
            <a-date-picker disabled v-model="localForm.date" valueFormat="YYYYMMDD" />
          </a-form-model-item>
          <a-form-model-item prop="number" label="编号">
            <a-input v-model="localForm.number" disabled />
          </a-form-model-item>
          <a-form-model-item prop="title" label="标题">
            <a-select disabled v-model="localForm.title">
              <a-select-option v-for="(val, index) in titleList" :key="index" :value="val.title">
                {{ val.title }}
              </a-select-option>
            </a-select>
          </a-form-model-item>
          <a-form-model-item prop="result" label="描述" v-if="localForm.title">
            <a-select disabled mode="tags" v-model="localForm.result">
              <a-select-option v-for="(val, index) in results" :key="index" :value="val.value">
                {{ val.label }}
              </a-select-option>
            </a-select>
          </a-form-model-item>
          <a-form-model-item prop="image" label="上传附件">
            <a-upload
              disabled
              :action="uploadUrl"
              :headers="uploadHeaders"
              list-type="picture"
              :file-list="localForm.image"
              @preview="handlePreview"
              :maxCount="3"
              name="file">
            </a-upload>
          </a-form-model-item>
        </a-form-model>
      </div>
    </a-modal>
    <a-modal :visible="previewVisible" :footer="null" @cancel="handleCancel">
      <img alt="example" style="width: 100%" :src="previewImage" />
    </a-modal>
  </div>
</template>

<script>
import { fromProductList } from "@/api/from";
import Cookies from 'js-cookie';

function getBase64(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = (error) => reject(error);
  });
}
const IMAGE_EXTS = ['.jpeg', '.jpg', '.png', '.gif', '.bmp', '.tiff', '.tif', '.webp', '.svg', '.ico', '.raw'];
function isImageFile(name) {
  if (!name) return false;
  return IMAGE_EXTS.some(ext => name.toLowerCase().endsWith(ext));
}
export default {
  name: "FormModal2",
  model: { prop: "visible", event: "cancel" },
  props: ["visible", "form", "clientsClassificationOptions"],
  data() {
    return {
      localVisible: this.visible,
      localForm: Object.assign({ product_id: undefined, date: '', number: '', title: '', result: [], image: [] }, this.form),
      previewImage: "",
      previewVisible: false,
      titleList: [
        { title: '原料验收', describe: ['原料索证齐全', '原料验收合格'] },
        { title: '生产投料', describe: ['根据订单生产'] },
        { title: '半成品检测', describe: ['半成品检测合格'] },
        { title: '成品检测', describe: ['成品检测合格'] },
        { title: '成品出库', describe: ['成品出库检测合格'] },
      ],
      productList: [],
      uploadUrl: process.env.VUE_APP_NEW_URL + '/comapi/UploadApi',
      rules: {},
      loading: false,
    };
  },
  computed: {
    uploadHeaders() {
      const token = Cookies.get('access');
      return token ? { Authorization: 'Bearer ' + token } : {};
    },
    results() {
      if (this.localForm.title) {
        const data = this.titleList.filter((item) => item.title === this.localForm.title);
        if (data.length > 0) {
          return data[0].describe.map((item) => ({ label: item, value: item }));
        }
        return [];
      }
      return [];
    }
  },
  watch: {
    visible(v) { this.localVisible = v; },
    form(v) { this.localForm = Object.assign({ product_id: undefined, date: '', number: '', title: '', result: [], image: [] }, v); },
  },
  created() {
    fromProductList({ page: 1, page_size: 9999 }).then((data) => {
      this.productList = data.data;
    });
  },
  methods: {
    async handlePreview(file) {
      const name = file.name || file.url || '';
      const url = file.url || (file.response && file.response.data && file.response.data.file_url) || '';
      if (!isImageFile(name)) {
        if (url) window.open(url, '_blank');
        return;
      }
      if (!file.url && !file.preview) {
        if (file.originFileObj instanceof Blob) {
          file.preview = await getBase64(file.originFileObj);
        } else if (file.response && file.response.data && file.response.data.file_url) {
          file.preview = file.response.data.file_url;
        } else {
          return;
        }
      }
      this.previewImage = file.url || file.preview;
      this.previewVisible = true;
    },
    handleCancel() {
      this.previewVisible = false;
    },
    confirm() {
      this.cancel();
    },
    cancel() {
      this.$emit("cancel", false);
    },
  },
};
</script>

<style scoped></style>
